import styled from 'styled-components';

export const Container = styled.div`
  box-shadow: var(--shadow);
  border-radius:4px;
  cursor: pointer;

  padding: 16px;
  margin-top: 16px;
  background: #D3D3D3;
  display: flex;
  flex-direction: column;

  transition: transform 0.2s;
  &:hover{
     transform: translateY(-4px);
  }
`;

export const WrapperHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  span{
    display: flex;
    align-items: center;
    font-weight: 700;
  }

  svg{
    font-size: 24px;
    margin-right: 8px;
  }

  h2{
    font-size: 1rem;
    font-weight: 700;
  }
`;
